// Der Pool «Templates» auf oberster Ebene enthält die Nexanet-Vorlagen: Nicht-Admins sehen ihn nicht, und seine
// Maschinen gelten im VM-Assistenten als «Nexanet-Templates». Nur das erste Segment zählt. Ein Unterverzeichnis
// mit dem Namen «templates» (z. B. «K123456/templates») ist ein gewöhnliches Kundenverzeichnis.
export const isTemplatesPoolBranch = (poolId) => {
  const first = String(poolId || '').split('/').map((segment) => segment.trim()).filter(Boolean)[0];
  return String(first || '').toLowerCase() === 'templates';
};
